import React, { ReactNode, useRef, useLayoutEffect, useState } from 'react';
import PdfHeader from '../PdfHeader/PdfHeader';
import PdfFooter from '../PdfFooter/PdfFooter';
import { usePaginatedChildren } from 'pages/Pdf/hooks/usePaginatedChildren';

interface PageWrapperProps {
  assetName: string;
  date: string;
  category: string;
  assetDescription?: string;
  className?: string;
  children: ReactNode;
  style?: React.CSSProperties;
  dataTestId?: string;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  className = 'light',
  children,
  style,
  dataTestId,
  ...props
}) => {
  const { pages, containerRef, measuring, flatChildren } = usePaginatedChildren(children);

  if (measuring) {
    return (
      <div
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', visibility: 'hidden' }}
        ref={containerRef}
      >
        {flatChildren?.map((child, idx) => (
          <React.Fragment key={idx}>{child}</React.Fragment>
        ))}
      </div>
    );
  }

  return (
    <>
      {pages.map((pageChildren, idx) => (
        <div className={`page-size pdf ${className}`} key={idx}>
          <PdfHeader {...props} />
          <div className="pdf-page-wrapper" style={style} data-testid={dataTestId}>
            {pageChildren}
          </div>
          <PdfFooter />
        </div>
      ))}
    </>
  );
};

export default PageWrapper;
